import React, { useEffect } from 'react'
import * as d3 from 'd3'
require('d3-selection-multi')
import './styles.scss'
export interface Props {
  lines: {
    number: number
    color: string
    background: string
    route: string
    notes: string
  }[]
  data: []
  minMax: [number, number]
  maxWidth: number
  svgID:string
}

const yStart = 6

export const BarChartComp = ({
  lines,
  data,
  minMax,
  maxWidth,
  svgID
}: Props) => {

  useEffect(() => {
    var scale = d3
      .scaleLinear()
      .domain(minMax)
      .range([0, maxWidth * 0.8 < 500 ? maxWidth * 0.8 : 500])

    var svg = d3.select('#' + svgID)

    var groups = svg.selectAll('g').data(data)

    var groupsenter = groups.enter().append('g')

    groupsenter.append('rect').attr('class', 'bar')
    groupsenter.append('rect').attr('class', 'label')
    groupsenter.append('text').attrs({ class: 'name', x: 10 })
    groupsenter.append('text').attr('class', 'value')

    var groupsmerge = groupsenter.merge(groups)

    groups
      .select('rect')
      .transition()
      .ease(d3.easeCubicIn)
      .delay(100)
      .attrs({
        width: d => {
          console.log(d)

          return scale(d.Mietpreis)
        }
      })
    groupsmerge
      .select('rect.bar')
      .attrs({
        x: 10,
        class: 'bar',
        fill: d => {
          return lines['L' + d.Haltestelle.replace('Linie ', '')].background
        },
        opacity: 0.3,
        height: 20,
        rx: 10,
        ry: 10,
        y: (d, i) => {
          svg.attr('height', 50 + i * 25 + 'px')
          return yStart + i * 25
        }
      })
      .transition()
      .attrs({
        width: d => {
          return scale(d.Mietpreis)
        }
      })
    groupsmerge.select('rect.label').attrs({
      x: 0,
      class: 'bar',
      fill: d => {
        return lines['L' + d.Haltestelle.replace('Linie ', '')].background
      },
      opacity: 1,
      height: 20,
      y: (d, i) => {
        svg.attr('height', 50 + i * 25 + 'px')
        return yStart + i * 25
      },
      width: 30
    })

    groupsmerge
      .select('text.name')
      .text(d => {
        return d.Haltestelle.replace('Linie ', '')
      })
      .attrs({
        'text-anchor': 'middle',
        fill: d => {
          return lines['L' + d.Haltestelle.replace('Linie ', '')].color
        },
        x:15,
        y: (d, i) => {
          return yStart + i * 25 + 16
        }
      })

    groupsmerge
      .select('text.value')
      .text(d => {
        return d.Mietpreis
      })
      .attrs({
        y: (d, i) => {
          return yStart + i * 25 + 16
        }
      })
      .transition()
      .attrs({
        x: d => {
          return scale(d.Mietpreis) +15
        }
      })
    groups.exit().remove()
  })

  return <></>
}
